module.exports = __webpack_public_path__ + "img/logo_makro_creativo_web-blanco.95305bb6.svg";